<template>
	<div class="" id="" style="">
		<header-vue></header-vue>
		<div class="container-l2">
			<div class="detail-content">
				<!--公司选择-->	
				<div class="clear text-right">
					<choose-company @event1="changeCom($event)" :areaFlag="areaFlag"></choose-company>
				</div>
				<!--最外层机房循环-->
				<div class="znjg-box" v-if="envInfo.length>0" v-for="(item,index) in envInfo">
					<h3 v-text="item.name"></h3>
					<div v-for="(sitem,skey,sindex) in item.devices" v-if="item.devices" :key="skey">
						<div class="znjg-boxs" v-if="ssitem.communityState && ssitem.communityState.isHealthy" v-for="(ssitem,ssindex) in sitem" :key="ssindex">
							<p class="title p12" v-text="ssitem.name"></p>
							<p class="p11" v-if="ssitem.communityState">
				              <i v-if="skey=='humiture'" class="fa fa-globe"></i>
				              <i v-if="skey=='smoke'" class="fa fa-free-code-camp"></i>
				              <i v-if="skey=='leakage'" class="fa fa-tint"></i>
				              <i v-if="skey=='fire'" class="fa fa-fire-extinguisher"></i>
							  <i v-if="skey=='door'" class="fa fa-columns"></i>
							  <i v-if="skey=='lamp'" class="fa fa-lightbulb-o"></i>
				              {{ssitem.communityState.name}}
				              <span class="num"
				                    :class="{'status danger':ssitem.communityState.isHealthy=='N',status:ssitem.communityState.value=='正常'}"
				                    v-text="ssitem.communityState.value"></span>
				            </p>
				            <p class="p11"  v-if="ssitem.dataList && ssitem.communityState.isHealthy=='Y'" v-for="(sssitem,sssindex) in ssitem.dataList" :key="sssindex">
				              <i v-if="skey=='humiture'" class="fa fa-globe"></i>
				              <i v-if="skey=='smoke'" class="fa fa-free-code-camp"></i>
				              <i v-if="skey=='leakage'" class="fa fa-tint"></i>
				              <i v-if="skey=='fire'" class="fa fa-fire-extinguisher"></i>
				              <i v-if="skey=='door'" class="fa fa-columns"></i>
				              <i v-if="skey=='lamp'" class="fa fa-lightbulb-o"></i>
				              {{sssitem.name}}
				              <em v-if="sssitem.unit">({{sssitem.unit}})</em>
				              <span class="num"
				                    :class="{'status danger':sssitem.isHealthy=='N',status:sssitem.value=='正常'}"
				                    v-text="sssitem.value"></span>
				            </p>
						</div>
					</div>
				</div>
				<div v-if="envInfo.length<=0">
					<p class="text-center dangerp mt120">无法获取数据或无相关设备！</p>
				</div>

			</div>

		</div>
	</div>
</template>

<script>
	import chooseCompany from './../comss/chooseCompany.vue'
	export default {
		components: {
		    chooseCompany
		   },
		mounted() {
			this.$nextTick(function() {
				this.getEnvList();

			})
			const timer = setInterval(() => {
				this.getEnvList();
			}, 5000);

			this.$once('hook:beforeDestroy', () => {
				clearInterval(timer);
			})

		},
		data() {
			return {
				activeIndex: 0,
				envInfo: [],
				ifHasInfo: true,
				// 公司组件参数
				selectComId: this.getCookie('company_id'),
				areaFlag: false
			}
		},
		methods: {
			changeCom(data){
				this.selectComId = data.selectComId || "";
			
			},
			// 选择公司及区域后调用方法
			toChooseCompanyMethod(){
				this.envInfo = [];
				this.getEnvList();
			},
			//获取空调列表开始
			getEnvList() {
				let valiCodeParams={
					uid:this.getCookie('uid'),
					company_id: this.selectComId || "",
			  		token:this.getCookie('token'),
			  		time:Date.parse( new Date()),
			  		terminalId:4
		  		};
		  		this.sign2(valiCodeParams);
		  		this.$ajax.post(this.$store.state.domain2+"/admin/Environment/EnvironmentList",this.$qs.stringify(valiCodeParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.code==200 & res.data.data!=null){
		        		
		        		this.envInfo = res.data.data;
		        		this.ifDetail = true;
		        		
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
					      this.$router.push('/login/');
					      this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		//console.log(res.data.msg);
		        		this.ifDetail = false;
		        	}
		  		});
			},
			//获取空调列表结束

		}
	}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/device/env.vue